import React from 'react'
import * as classes from './TextImage.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Button from './Button'

declare const twq: (event: string, id: string, params: object) => void

const handleCtaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  console.log('button click')
  const href = e.currentTarget.href
  const isNewTab = e.currentTarget.target === '_blank'

  if (typeof twq === 'function') {
    if (!isNewTab) {
      e.preventDefault()
      twq('event', 'tw-r3t8x-rcd0t', {})
      setTimeout(() => { window.location.href = href }, 300)
    } else {
      twq('event', 'tw-r3t8x-rcd0t', {})
    }
  }
}

const TextImage = ({ text, image, ctaButton, ctaButtonSecondary }) => {
  if (!text || !image) return <></>
  return (
    <section className={`${classes.bgLight}`}>
      <div className={`container ${classes.textImage}`}>
        <div className={classes.left}>
          <div className={classes.contentContainer}>
            {documentToReactComponents(text)}
          </div>
              {(ctaButton || ctaButtonSecondary) && (
                <div className={classes.ctaContainer}>
                  {ctaButton && <Button button={ctaButton} onClick={handleCtaClick} />}
                  {ctaButtonSecondary && <Button button={ctaButtonSecondary} onClick={handleCtaClick} />}
                </div>
              )}
        </div>
        <div className={classes.right}>
          <link
            rel="preload"
            fetchPriority="high"
            as="image"
            href={`${image.file?.url}?fm=webp&w=620`}
            type="image/webp"
          />
          <img
            src={`${image.file?.url}?fm=webp&w=620`}
            srcSet={`${image.file?.url}?fm=webp&h=300 311w, ${image.file?.url}?fm=webp&w=620 312w`}
            width={image.file?.details?.image?.width}
            height={image.file?.details?.image?.height}
            alt={image.title}
          />
        </div>
      </div>
    </section>
  )
}

export default TextImage
